import { render, staticRenderFns } from "./GestionInspeccionHidrocarburos.vue?vue&type=template&id=8a577fe2"
import script from "./GestionInspeccionHidrocarburos.vue?vue&type=script&lang=js"
export * from "./GestionInspeccionHidrocarburos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports